import React from "react";
import PropTypes from "prop-types";
import Heading, { HeadingSizeEnum } from "../Heading/Heading";

const HeadingGroup = ({ titleLevel = 2, titleLabel, subtitleLabel }) => {
    const resolvedLevel =
        typeof titleLevel === "number"
            ? HeadingSizeEnum[`h${titleLevel}`] || `h${titleLevel}`
            : titleLevel;
    return (
        <hgroup>
            <Heading
                label={titleLabel}
                size={resolvedLevel}
            />
            {subtitleLabel && (
                <p className="mt-16 laptop:mt-24">{subtitleLabel}</p>
            )}
        </hgroup>
    );
};

HeadingGroup.propTypes = {
    titleLevel: PropTypes.oneOfType([
        PropTypes.oneOf(Object.values(HeadingSizeEnum)),
        PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
    ]),
    titleLabel: PropTypes.string.isRequired,
    subtitleLabel: PropTypes.string,
};

export default HeadingGroup;
